import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Categories } from "../components/site/Categories";
import { Services } from "../components/site/Services";
import { Method } from "../components/site/Method";
import { Quote } from "../components/site/Quote";
import { Press } from "../components/site/Press";
import { PressArticles } from "../components/site/PressArticles";
import { Credentials } from "../components/site/Credentials";
import { Faq } from "../components/site/Faq";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

export default function Home() {
  return (
    <div data-variant="vault" data-testid="site-root" className="site-root min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Categories />
        <Services />
        <Method />
        <Quote />
        <Press />
        <PressArticles />
        <Credentials />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
